module.exports = __webpack_public_path__ + "static/card_front.67d4077a.png";